import { Component, EventEmitter, OnInit, Output } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-terminos-ycondiciones-modal',
  templateUrl: './terminos-ycondiciones-modal.component.html',
  styleUrls: []
})
export class TerminosYCondicionesModalComponent implements OnInit {

  // I/O
  @Output() onSendFormContact: EventEmitter<boolean> = new EventEmitter<boolean>()

  constructor() {
    // This is intentional
  }

  ngOnInit(): void {
    // This is intentional
  }

  public OpenModal() {
    $('#modal').modal('show');
  }

  public SendFormContact(acepta: boolean) {
    this.onSendFormContact.emit(acepta)
  }

}
